import React, { Component } from 'react';
import { Container } from 'reactstrap';
import ContentLoader from "../../components/ContentLoader";
import JobsInterestSection
    from "../../components/portfolio/JobsPage/JobsInterestSection";
import MetaTags from '../../components/SEO/MetaTags'
import { Request } from '../../helpers/request'
import { addLocalePrefix } from '../../components/Routes/LocaleLink'
import DigitalJobsInterestSection
    from "../../components/portfolio/JobsPage/DigitalJobsInterestSection";

class DigitalJobsViewPage extends Component {
    state = {
        title: '',
        description: '',
        business_unit: '',
        content: '',
        locale: '',
        seo_title: null,
        seo_description: null,
        loading: false,
        ready: false,
        linked_digital_jobs: null,
        linked_job_orders: null
    };

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.job !== this.props.match.params.job) {
            this.fetch()
        }
    }

    fetch = () => {
        Request.get('digital_jobs/slug/' + this.props.match.params.job)
            .then(data => {
                const digital_job_data = data.digital_job;
                this.setState({
                    ...digital_job_data,
                    linked_digital_jobs: data.linked_digital_jobs,
                    linked_job_orders: data.linked_job_orders,
                    ready: true,
                });
            })
            .catch(() => this.props.history.push(addLocalePrefix('/404')))
    };

    render() {
        return (
            <div className="digital-job-page">
                {this.renderDigitalJob()}
                {<DigitalJobsInterestSection linked_digital_jobs={this.state?.linked_digital_jobs} />}
                {<JobsInterestSection linked_job_orders={this.state?.linked_job_orders}/>}
            </div>
        )
    }

    renderDigitalJob() {
        if (!this.state.ready)
            return <ContentLoader />;

        let color = this.state.business_unit === 'tech' ? 'heading-primary' :
            this.state.business_unit === 'marketing' || this.state.business_unit === 'sales' ? 'heading-regular' : 'heading-warning';

        return (
            <section className="digital-job-details">
                <MetaTags page="digital_slug" data={this.state} />
                <Container>
                    <div className="digital-job-details-wrap">
                        <div className={`digital-job-heading ${color}`}>
                            <h1 className={`digital-job-title`}>
                                {this.state.title}
                            </h1>
                            <div className='digital-job-description'>
                                {this.state.description}
                            </div>
                        </div>
                        <div className="notice-text">
                            <div
                                className="blog-text-inner ck-content"
                                dangerouslySetInnerHTML={{
                                    __html: this.state.content
                                }}>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        )
    }
}

export default DigitalJobsViewPage;
